<template>
  <div class="self_evaluation">
    <div class="tabs">
      <span></span>企业介绍
      <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
        <i v-show="isEdit" class="tabs_one" @click="goEssentialInformation"></i>
      </el-tooltip>
    </div>
    <el-form :inline="true" label-width="80px" ref="ruleFormDataOne" :rules="rules" :model="FormDataOne">
      <el-form-item prop="translation">
        <el-input type="textarea" v-model="FormDataOne.translation" :rows="8" :disabled="isDis"
          placeholder="北京中科凡语科技有限公司由中科院自动化研究所模式识别国家重点实验室自然语言处理研究团队创立，依托中科院自动化所在人工智能、机器翻译和自然语言处理等 方面的深厚积累，面向跨语言、跨领域研究，提供机器翻译系统、多语言信息分析与处理服务与解决方案。其多语言机器翻译和多语言信息分析与处理系统已经广泛应 用于政府、医疗、科技和商务等多个领域，在用户中赢得了良好的口碑。（500字以内）">
        </el-input>
      </el-form-item>

    </el-form>
    <div class="btn" v-if="!isDis">
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button class="preservation" @click="preservation">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  computed: {
    isEdit () {
      if (this.auditStatus === 1) {
        return false
      } else {
        return this.isDis
      }
    },
  },
  watch: {
    userInfo: {
      handler (newVale, oldVale) {
        if (newVale.num === 1) {
          this.id = newVale.id
          this.certificateUrls = newVale.businessLicenseUrls
          this.auditStatus = newVale.auditStatus
          this.FormDataOne.translation = newVale.companyIntro
          this.dataObj = { ...this.FormDataOne } // 解构对象，取消操作用解构对象
        }
      },
      deep: true,
      immediate: true
    },
  },

  data () {
    let translationRules = (rule, value, callback) => {

      if (value !== null) {
        if (value !== "") {
          if (value.length < 50) {
            return callback(new Error("企业介绍不能少于50个字符"));
          }
          if (value.length > 500) {
            return callback(new Error("企业介绍不能大于500个字符"));
          }
        }
      }
      callback();

    };
    return {
      certificateUrls: [],
      auditStatus: null,
      FormDataOne: {
        translation: ""
      },
      rules: {
        translation: [
          { required: true, validator: translationRules, trigger: 'blur' },
        ]
      },
      isDis: true,
      id: null,
    };
  },

  methods: {
    goEssentialInformation () {
      this.isDis = false
    },

    async  preservation () {
      let verify = true;
      this.$refs.ruleFormDataOne.validateField(["translation",], errTip => {
        if (errTip) {
          // 会调用多次
          verify = false;
        }
      })
      if (verify) {

        let url = "/v1/userRegister/add_or_update_company_register_info"
        let myUser = JSON.parse(localStorage.getItem("myUser"))
        if (!this.certificateUrls) {
          this.certificateUrls = []
        }
        let params = {
          id: this.id,
          auditStatus: this.auditStatus === 0 ? 0 : 2,
          userId: myUser.id,
          companyIntro: this.FormDataOne.translation,
          businessLicenseUrls: this.certificateUrls
        }
        const res = await this.catReq1Service(url, params)
        if (res.resultCode === "1") {
          this.isDis = true;
          this.$emit("succe", res.result)
        }
      }
    },
    cancel () {
      this.$refs['ruleFormDataOne'].clearValidate();
      this.FormDataOne = { ...this.dataObj }
      this.isDis = true;
    },
  },
};
</script>

<style lang="less" scoped>
.self_evaluation {
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
    .tabs_one {
      display: inline-block;
      cursor: pointer;
      width: 16px;
      height: 16px;
      background: url("../../assets/imgs/authentication/modify_normal.png")
        no-repeat;
      background-size: cover;
      margin-left: 10px;
      &:active {
        background: url("../../assets/imgs/authentication/modify_press.png")
          no-repeat;
      }
    }
  }
  /deep/.el-form {
    .el-form-item {
      width: 100%;
      .el-form-item__content {
        width: 100%;
        .el-textarea {
          width: 100%;
          textarea {
            resize: none;
          }
        }
      }
    }
  }
  .add_work_experience {
    display: flex;
    cursor: pointer;
    float: left;
    margin-left: 10px;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background: url("../../assets/imgs/editor/add_to_normal.png") no-repeat;
      background-size: cover;
    }
    span {
      display: inline-block;
      line-height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-left: 5px;
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
</style>
